export type MemberFileKind = 'pdf' | 'zip' | 'image' | 'file'

export function memberFileKind(name: string, contentType?: string): MemberFileKind {
  const type = (contentType ?? '').toLowerCase()
  const lower = name.toLowerCase()
  if (type.includes('pdf') || lower.endsWith('.pdf')) return 'pdf'
  if (type.includes('zip') || lower.endsWith('.zip')) return 'zip'
  if (type.startsWith('image/') || /\.(png|jpe?g|webp)$/.test(lower)) return 'image'
  return 'file'
}

export function memberFileKindLabel(kind: MemberFileKind) {
  if (kind === 'pdf') return 'PDF'
  if (kind === 'zip') return 'ZIP'
  if (kind === 'image') return 'IMG'
  return 'ARQ'
}
